import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "../../components";
import {
  FormGroup,
  FormGroupInput,
  FormGroupVerticalInput,
  TextInput,
  CheckboxInput,
  ColorInput,
  ColoredSpan,
  Icon,
} from "../../components";
import Table from "../../components/table/Table";
import { range } from "../../utils/array-utils";
import { hasErrorInput } from "../../utils";
import CommonToAllModalHelp from "./CommonToAllModalHelp";
import HintIconToolTip from "../../components/HintIconToolTip";

function CommonToAll({ settings, onSettingChange, onSubmit, errors }) {
  const [openModalHelp, setOpenModalHelp] = useState(false);
  const setColorSetting = (color, itemName) => {
    onSettingChange(itemName, color);
  };

  const setSettingValue = (e) => {
    onSettingChange(e.target.name, e.target.value);
  };

  const handleChangeCheckSetting = (e) => {
    onSettingChange(e.target.name, e.target.checked);
  };

  const handleChangeGroupActive = (
    e,
    level,
    settingName,
    isMachine = false
  ) => {
    onSettingChange(e.target.name, e.target.checked);
    if (settingName === "active") {
      if (e.target.checked) {
        for (let i = 1; i <= level; i++) {
          onSettingChange(`group_${i}_${settingName}`, e.target.checked);
        }
      } else {
        for (let i = level + 1; i <= 5; i++) {
          onSettingChange(`group_${i}_${settingName}`, e.target.checked);
        }
      }
    }
    // if (!isMachine) {
    //   if (e.target.checked) {
    //     for (let i = 1; i <= level - 1; i++) {
    //       onSettingChange(`group_${i}_${settingName}`, e.target.checked);
    //     }
    //   } else {
    //     for (let i = level + 1; i <= 5; i++) {
    //       onSettingChange(`group_${i}_${settingName}`, e.target.checked);
    //       if (settingName !== 'active') {
    //         onSettingChange(`machine_${settingName}`, e.target.checked);
    //       }
    //     }
    //   }
    // } else {
    //   if (e.target.checked) {
    //     for (let i = 1; i <= level; i++) {
    //       onSettingChange(`group_${i}_${settingName}`, e.target.checked);
    //     }
    //   }
    // }
  };

  return (
    <div
      className="bg-white 2xl:px-[60px] xl:px-10 xl:py-[30px] px-5 py-5 w-fit 2xl:w-[1240px] border border-tenken-gray-300 rounded-lg"
      role="tabpanel"
    >
      <h4 className="text-tenken-tablet-heading-4 xl:text-tenken-heading-4 font-bold text-center">
        全画面共通
      </h4>
      <div className="py-2 flex">
        <label>■ アプリケーション</label>
      </div>
      <div className="lg:mt-2 mt-1 border border-tenken-gray-250 max-w-[750px]">
        <div className="border-b border-tenken-gray-250 flex">
          <div className="bg-tenken-gray-070 lg:w-[240px] min-w-[200px] w-40 border-r border-tenken-gray-250 lg:py-4 py-2 lg:px-4 px-2">
            <div className="flex">
              <label>アプリケーション名</label>
            </div>
          </div>
          <div className="lg:py-4 lg:px-6 py-2 px-3 lg:w-[460px]">
            <FormGroup
              direction="vertical"
              className="!mb-0"
              inputWidth="w-[280px]"
            >
              <label className="mb-1">
                アプリケーション名を入力してください
              </label>
              <FormGroupInput>
                <TextInput
                  type="text"
                  name="app_name"
                  value={settings.app_name ?? ""}
                  onChange={setSettingValue}
                  hasError={hasErrorInput(errors, "app_name")}
                  className="lg:w-[440px] w-[400px]"
                  maxLength={25}
                />
              </FormGroupInput>
            </FormGroup>
          </div>
        </div>
        <div className="flex">
          <div className="bg-tenken-gray-070 lg:w-[240px] min-w-[200px] w-40 border-r border-tenken-gray-250 lg:py-4 py-2 lg:px-4 px-2">
            <div className="flex">
              <p className="text-left flex items-center">ログアウト時間</p>
            </div>
          </div>
          <div className="lg:py-4 lg:px-6 py-2 px-3 lg:w-[460px]">
            <FormGroup direction="vertical" className="!mb-0">
              <label className="mb-1">
                自動ログアウト時間を入力してください
              </label>
              <FormGroupInput>
                <div className="flex items-center">
                  <TextInput
                    type="text"
                    className="w-[80px]"
                    name="refresh_token_lifetime"
                    value={settings.refresh_token_lifetime ?? ""}
                    onChange={setSettingValue}
                    hasError={hasErrorInput(errors, "refresh_token_lifetime")}
                  />
                  <p className="ml-2">分</p>
                </div>
              </FormGroupInput>
            </FormGroup>
          </div>
        </div>
      </div>
      <div className="py-2 flex">
        <label>■ 設備グループフィールド</label>
        <div className="lg:ml-2 ml-1 lg:mt-[2px]">
          <HintIconToolTip>
            <h4>■設備入力値のマッピング</h4>
            <p>設備マスタと設備入力値の紐づけを行います</p>
            <br />
            <p>（例）設備グループ１を選択</p>
            <p>設備マスタの設備グループ１フィールドを設備入力値と紐づけます</p>
          </HintIconToolTip>
        </div>
      </div>
      <h5 className="lg:mt-2 text-left xl:text-tenken-body font-light">
        フィールド表示名の入力欄に、フィールド名を入力してください
      </h5>
      <div className="mt-4 relative rounded-lg border border-tenken-gray-300 lg:max-w-[1040px] max-w-[920px]">
        <Table striped className="text-tenken-gray-900">
          <Table.Head>
            <Table.HeadCell className="whitespace-nowrap">
              フィールド名
            </Table.HeadCell>
            <Table.HeadCell className="whitespace-nowrap">
              フィールド表示名
            </Table.HeadCell>
            <Table.HeadCell className="text-center whitespace-nowrap">
              表示 or 非表示
            </Table.HeadCell>
            <Table.HeadCell className="text-center whitespace-nowrap">
              ユニーク設定
            </Table.HeadCell>
            <Table.HeadCell className="text-center whitespace-nowrap">
              複合ユニーク設定
            </Table.HeadCell>
          </Table.Head>
          <Table.Body>
            {range(1, 5).map((i) => (
              <Table.Row key={i}>
                <Table.Cell className="whitespace-nowrap">
                  <span>{`設備グループ${i}`}</span>
                </Table.Cell>
                <Table.Cell>
                  <FormGroup direction="vertical" className="!mb-0">
                    <FormGroupInput>
                      <TextInput
                        type="text"
                        className="lg:w-[264px] w-[248px]"
                        name={`group_${i}_name`}
                        value={settings[`group_${i}_name`] ?? ""}
                        onChange={setSettingValue}
                        maxLength={15}
                        hasError={hasErrorInput(errors, `group_${i}_name`)}
                      />
                    </FormGroupInput>
                  </FormGroup>
                </Table.Cell>
                <Table.Cell>
                  <CheckboxInput
                    position="justify-center"
                    name={`group_${i}_active`}
                    checked={settings[`group_${i}_active`]}
                    onChange={(e) => {
                      handleChangeGroupActive(e, i, "active");
                    }}
                    disabled={i === 1}
                  />
                </Table.Cell>
                <Table.Cell>
                  <CheckboxInput
                    position="justify-center"
                    name={`group_${i}_is_unique`}
                    checked={settings[`group_${i}_is_unique`]}
                    onChange={(e) => {
                      handleChangeGroupActive(e, i, "is_unique");
                    }}
                  />
                </Table.Cell>
                <Table.Cell>
                  <CheckboxInput
                    position="justify-center"
                    name={`group_${i}_in_group_unique`}
                    checked={settings[`group_${i}_in_group_unique`]}
                    onChange={(e) => {
                      handleChangeGroupActive(e, i, "in_group_unique");
                    }}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
            <Table.Row>
              <Table.Cell>設備No.</Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupInput>
                    <TextInput
                      type="text"
                      className="lg:w-[264px] w-[248px]"
                      name="machine_name"
                      value={settings["machine_name"] ?? ""}
                      onChange={setSettingValue}
                      hasError={hasErrorInput(errors, `machine_name`)}
                      maxLength={15}
                    />
                  </FormGroupInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <CheckboxInput
                  position="justify-center"
                  name="machine_active"
                  checked={settings["machine_active"]}
                  disabled={true}
                />
              </Table.Cell>
              <Table.Cell>
                <CheckboxInput
                  position="justify-center"
                  name="machine_is_unique"
                  checked={settings["machine_is_unique"]}
                  onChange={(e) => {
                    handleChangeCheckSetting(e);
                    handleChangeGroupActive(e, 5, "is_unique", true);
                  }}
                />
              </Table.Cell>
              <Table.Cell>
                <CheckboxInput
                  position="justify-center"
                  name="machine_in_group_unique"
                  checked={settings["machine_in_group_unique"]}
                  onChange={(e) => {
                    handleChangeCheckSetting(e);
                    handleChangeGroupActive(e, 5, "in_group_unique", true);
                  }}
                />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
      <div className="py-2 flex">
        <label>■点検結果フィールド</label>
      </div>
      <div className="lg:mt-2 lg:max-w-[520px] max-w-[440px] relative rounded-lg border border-tenken-gray-300">
        <Table striped className="text-tenken-gray-900">
          <Table.Head>
            <Table.HeadCell className="whitespace-nowrap">
              フィールド名
            </Table.HeadCell>
            <Table.HeadCell className="whitespace-nowrap">
              フィールド表示名
            </Table.HeadCell>
          </Table.Head>
          <Table.Body>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">
                点検開始日時
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupInput>
                    <TextInput
                      type="text"
                      className="lg:w-[264px] w-[248px]"
                      value={settings.inspection_start_datetime ?? ""}
                      name="inspection_start_datetime"
                      onChange={setSettingValue}
                      maxLength={15}
                      hasError={hasErrorInput(
                        errors,
                        "inspection_start_datetime"
                      )}
                    />
                  </FormGroupInput>
                </FormGroup>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">
                点検開始担当者
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupInput>
                    <TextInput
                      type="text"
                      className="lg:w-[264px] w-[248px]"
                      value={settings.inspection_start_user_id ?? ""}
                      name="inspection_start_user_id"
                      onChange={setSettingValue}
                      maxLength={15}
                      hasError={hasErrorInput(
                        errors,
                        "inspection_start_user_id"
                      )}
                    />
                  </FormGroupInput>
                </FormGroup>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">
                稼働開始日時
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupInput>
                    <TextInput
                      type="text"
                      className="lg:w-[264px] w-[248px]"
                      value={settings.operation_start_datetime ?? ""}
                      name="operation_start_datetime"
                      onChange={setSettingValue}
                      maxLength={15}
                      hasError={hasErrorInput(
                        errors,
                        "operation_start_datetime"
                      )}
                    />
                  </FormGroupInput>
                </FormGroup>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">
                稼働開始担当者
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupInput>
                    <TextInput
                      type="text"
                      className="lg:w-[264px] w-[248px]"
                      value={settings.operation_start_user_id ?? ""}
                      name="operation_start_user_id"
                      onChange={setSettingValue}
                      maxLength={15}
                      hasError={hasErrorInput(
                        errors,
                        "operation_start_user_id"
                      )}
                    />
                  </FormGroupInput>
                </FormGroup>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">
                点検登録日時
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupInput>
                    <TextInput
                      type="text"
                      className="lg:w-[264px] w-[248px]"
                      value={settings.registration_datetime ?? ""}
                      name="registration_datetime"
                      onChange={setSettingValue}
                      maxLength={15}
                      hasError={hasErrorInput(errors, "registration_datetime")}
                    />
                  </FormGroupInput>
                </FormGroup>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
      <div className="py-2 flex items-center">
        <label>■点検結果記号</label>
        <button onClick={() => setOpenModalHelp(true)}>
          <Icon name="idea" className="ml-1 w-5 h-5" />
        </button>
      </div>
      <h5 className="lg:mt-2 text-left xl:text-tenken-body font-light">
        点検結果を表す記号について設定してください
      </h5>
      <div className="lg:mt-4 mt-2 relative rounded-lg border border-tenken-gray-300">
        <Table striped className="text-tenken-gray-900">
          <Table.Head>
            <Table.HeadCell className="whitespace-nowrap">
              点検結果
            </Table.HeadCell>
            <Table.HeadCell className="whitespace-nowrap">
              登録状態
            </Table.HeadCell>
            <Table.HeadCell className="whitespace-nowrap">
              点検項目種類
            </Table.HeadCell>
            <Table.HeadCell className="whitespace-nowrap">記号</Table.HeadCell>
            <Table.HeadCell className="whitespace-nowrap">
              文字色
            </Table.HeadCell>
            <Table.HeadCell className="whitespace-nowrap">
              行背景色
            </Table.HeadCell>
            <Table.HeadCell className="whitespace-nowrap">
              プレビュー
            </Table.HeadCell>
          </Table.Head>
          <Table.Body>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">点検OK</Table.Cell>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <TextInput
                      type="text"
                      className="2xl:w-[100px] w-[80px] text-center"
                      name="passed_symbol"
                      value={settings.passed_symbol ?? ""}
                      onChange={setSettingValue}
                      maxLength={2}
                      hasError={hasErrorInput(errors, "passed_symbol")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.passed_color}
                      setColor={setColorSetting}
                      itemName="passed_color"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(errors, "passed_color")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.passed_background}
                      setColor={setColorSetting}
                      itemName="passed_background"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(errors, "passed_background")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <ColoredSpan
                  className="p-1"
                  color={settings.passed_color}
                  background={settings.passed_background}
                >
                  {settings?.passed_symbol?.trim()}
                </ColoredSpan>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">点検NG</Table.Cell>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <TextInput
                      type="text"
                      className="2xl:w-[100px] w-[80px] text-center"
                      name="failed_symbol"
                      value={settings.failed_symbol ?? ""}
                      onChange={setSettingValue}
                      maxLength={2}
                      hasError={hasErrorInput(errors, "failed_symbol")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.failed_color}
                      setColor={setColorSetting}
                      itemName="failed_color"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(errors, "failed_color")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.failed_background}
                      setColor={setColorSetting}
                      itemName="failed_background"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(errors, "failed_background")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <ColoredSpan
                  className="p-1"
                  color={settings.failed_color}
                  background={settings.failed_background}
                >
                  {settings?.failed_symbol?.trim()}
                </ColoredSpan>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">処置完了済</Table.Cell>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <TextInput
                      type="text"
                      className="2xl:w-[100px] w-[80px] text-center"
                      name="treatment_completed_symbol"
                      value={settings.treatment_completed_symbol ?? ""}
                      onChange={setSettingValue}
                      maxLength={2}
                      hasError={hasErrorInput(
                        errors,
                        "treatment_completed_symbol"
                      )}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.treatment_completed_color}
                      setColor={setColorSetting}
                      itemName="treatment_completed_color"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(
                        errors,
                        "treatment_completed_color"
                      )}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.treatment_completed_background}
                      setColor={setColorSetting}
                      itemName="treatment_completed_background"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(
                        errors,
                        "treatment_completed_background"
                      )}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <ColoredSpan
                  className="p-1"
                  color={settings.treatment_completed_color}
                  background={settings.treatment_completed_background}
                >
                  {settings?.treatment_completed_symbol?.trim()}
                </ColoredSpan>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell className="whitespace-nowrap">
                未点検/未承認
              </Table.Cell>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <TextInput
                      type="text"
                      className="2xl:w-[100px] w-[80px] text-center"
                      name="not_inspected_symbol"
                      value={settings.not_inspected_symbol ?? ""}
                      onChange={setSettingValue}
                      maxLength="2"
                      hasError={hasErrorInput(errors, "not_inspected_symbol")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.not_inspected_color}
                      setColor={setColorSetting}
                      itemName="not_inspected_color"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(errors, "not_inspected_color")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.not_inspected_background}
                      setColor={setColorSetting}
                      itemName="not_inspected_background"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(
                        errors,
                        "not_inspected_background"
                      )}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <ColoredSpan
                  className="p-1"
                  color={settings.not_inspected_color}
                  background={settings.not_inspected_background}
                >
                  {settings?.not_inspected_symbol?.trim()}
                </ColoredSpan>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell className="whitespace-nowrap">-</Table.Cell>
              <Table.Cell className="whitespace-nowrap">OKNG対象外</Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <TextInput
                      type="text"
                      className="2xl:w-[100px] w-[80px] text-center"
                      name="other_okng_symbol"
                      value={settings.other_okng_symbol ?? ""}
                      onChange={setSettingValue}
                      maxLength="2"
                      hasError={hasErrorInput(errors, "other_okng_symbol")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.other_okng_color}
                      setColor={setColorSetting}
                      itemName="other_okng_color"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(errors, "other_okng_color")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <FormGroup direction="vertical" className="!mb-0">
                  <FormGroupVerticalInput>
                    <ColorInput
                      color={settings.other_okng_background}
                      setColor={setColorSetting}
                      itemName="other_okng_background"
                      width="2xl:w-[160px] w-[140px]"
                      hasError={hasErrorInput(errors, "other_okng_background")}
                    />
                  </FormGroupVerticalInput>
                </FormGroup>
              </Table.Cell>
              <Table.Cell>
                <ColoredSpan
                  className="p-1"
                  color={settings.other_okng_color}
                  background={settings.other_okng_background}
                >
                  {settings?.other_okng_symbol?.trim()}
                </ColoredSpan>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
      <div className="mt-[50px] flex justify-center mb-[15px]">
        <Button
          color="yellow"
          className="min-w-[220px]"
          onClick={onSubmit}
          id="btn-setting-update"
        >
          更新
        </Button>
      </div>
      <CommonToAllModalHelp
        openModal={openModalHelp}
        setOpenModal={setOpenModalHelp}
      />
    </div>
  );
}

CommonToAll.propTypes = {
  show: PropTypes.bool,
};

export default CommonToAll;
